export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  const phoneRegex = /^(\+|00)?[1-9][0-9]{8,14}$/;
  return phoneRegex.test(phoneNumber.replace(/\s/g, ''));
};

export const isValidStringParameter = (parameter: string): boolean => {
  return parameter !== null && parameter !== undefined && parameter.trim() !== '';
};